import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

/**
 * The tax statement every booking flow prints beside a price (#2959).
 *
 * One place, because the question has one answer per tenant: a §19 UStG small
 * business charges no VAT, so "inkl. Steuern" is a price statement it may not
 * make. The flag is the same `tenant.is_kleinunternehmer` the admin pricing and
 * the invoice read (served by `GET /app/tenant-config/:slug`), so the app cannot
 * say something the invoice contradicts.
 *
 * A bundled (legacy) tenant carries no flag and keeps the standing wording —
 * §19 is not settable on the legacy stores (#2959, decided 2026-09-29).
 *
 * `sentence` sits under a total; `short` sits next to a price in a list.
 */
export const useTaxStatement = (): {
  isSmallBusiness: boolean;
  sentence: string;
  short: string;
} => {
  const { t } = useTranslation();
  const isSmallBusiness = useSelector(
    (state: RootState) => state.tenantConfig.config?.isKleinunternehmer === true
  );
  return isSmallBusiness
    ? {
        isSmallBusiness,
        sentence: t("book_location.small_business_tax_note"),
        short: t("book_location.small_business_tax_short"),
      }
    : {
        isSmallBusiness,
        sentence: t("book_location.confirmation.tax_information"),
        short: t("book_location.includes_tax"),
      };
};
